import React from 'react';
import { isNil } from 'lodash-es';

import {
  Theme,
  WithStyles,
  withStyles,
  createStyles,
} from '@material-ui/core/styles';
import { AppBar, Toolbar, Button } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    logoImg: {
      height: theme.spacing(6),
    },
  });

interface Props extends WithStyles<typeof styles> {
  leftLogo?: string;
  rightLogo: string;
}

class Header extends React.Component<Props> {
  static defaultProps = {
    rightLogo: '',
  };

  render() {
    const { leftLogo, rightLogo, classes } = this.props;
    return (
      <AppBar color="default" position="static">
        <Toolbar>
          {!isNil(leftLogo) && (
            <Button
              color="inherit"
              aria-label="Logo"
              style={{ marginRight: 9 }}
            >
              <img className={classes.logoImg} src={leftLogo} alt="logo" />
            </Button>
          )}
          <div style={{ flex: 1 }} />
          <Button color="inherit" aria-label="Logo" style={{ marginRight: 9 }}>
            <img className={classes.logoImg} src={rightLogo} alt="logo" />
          </Button>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styles)(Header);
